import {
    Component, OnInit, AfterViewInit, OnDestroy, Input, ViewChild,
    ElementRef, Renderer2, /* HostListener,*/ ViewEncapsulation, NgZone
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchEditionService } from '../../../services/search-edition.service';
import { CriticalEditionService } from '../../../services/critical-edition.service';
import { AppContentsService } from '../../../services/app-contents.service';
import { CeTooltipService } from '../../../services/ce-tooltip.service';
import { CeSelection } from '../../../models/ce-selection';
import { SearchEditionResultRow, extractKwicInnerHtml, isTeiHeadKwic } from '../../../models/search-edition-results';
import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';

/* Apparatus navigation tab names */
export type CeApparatusTabs = 'Apparatus' | 'Notes' | 'Bibliography' | 'TranslationEng' | 'TranslationLat' | 'CairoEd' | 'Legend';

@Component({
  selector: 'app-ce-apparatus',
  templateUrl: './ce-apparatus.component.html',
  styleUrls: ['./ce-apparatus.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CeApparatusComponent implements OnInit, OnDestroy, AfterViewInit {
    private subscriptions: Array<ISubscription> = [];
    private listeners: Array<any> = [];
    @Input() expandedImage: boolean;
    @Input() editionSample: boolean;
    @ViewChild('ceApparatus') ceApparatusRef: ElementRef;
    @ViewChild('ceExegeticNotes') ceExegeticNotesRef: ElementRef;
    @ViewChild('ceBibliography') ceBibliographyRef: ElementRef;
    @ViewChild('ceTranslationEng') ceTranslationEngRef: ElementRef;
    @ViewChild('ceTranslationLat') ceTranslationLatRef: ElementRef;
    @ViewChild('ceCairoEd') ceCairoEdRef: ElementRef;
    @ViewChild('ceLegend') ceLegendRef: ElementRef;
    ceApparatusHTML: SafeHtml;
    ceExegeticNotesHTML: SafeHtml;
    ceBibliographyHTML: SafeHtml;
    ceTranslationEngHTML: SafeHtml;
    ceTranslationLatHTML: SafeHtml;
    ceCairoEdHTML: SafeHtml;
    ceLegendHTML: SafeHtml;
    private appSelection: CeSelection;
    private contentSelection: CeSelection;
    private noteSelection: CeSelection;
    private biblioSelection: CeSelection;
    private divSelection: string;
    private appsSelected: any;
    private notesSelected: any;
    private biblioSelected: any;
    private divSelected: any;
    private witnessSelected: any;
    private searchResult?: SearchEditionResultRow;
    private searchResultContainerHtml: string;
    activeTab: CeApparatusTabs = 'Apparatus';
    existsTransEng: boolean;
    existsTransLat: boolean;
    existsCairoEd: boolean;
    existsLegend: boolean;
//    private fixed: boolean;
    ceCairoEdLastUpdate: string;
    ceLegendLastUpdate: string;

    constructor(
        private router: Router,
        private zone: NgZone,
        private activeRoute: ActivatedRoute,
        private renderer: Renderer2,
        private sanitizer: DomSanitizer,
        private criticalEditionService: CriticalEditionService,
        private appContentsService: AppContentsService,
        private tooltipService: CeTooltipService,
        private searchEditionService: SearchEditionService
    ) {
    }

//    @HostListener('window:scroll', ['$event'])
//    onWindowScroll($event) {
//        const scrollTop = $event.target.scrollingElement.scrollTop || $event.target.documentElement.scrollTop;
//        if (scrollTop > 360) {
//            this.renderer.setStyle(this.ceApparatusRef.nativeElement, 'position', 'fixed');
//            this.renderer.setStyle(this.ceApparatusRef.nativeElement, 'top', '37px');
//            this.fixed = true;
//        } else if (this.fixed && scrollTop < 350) {
//            this.renderer.setStyle(this.ceApparatusRef.nativeElement, 'position', 'static');
//            this.fixed = false;
//        }
//    }

    ngOnInit(): void {
        this.ceApparatusHTML = globals.html_small_loading_gif;
        this.ceExegeticNotesHTML = globals.html_small_loading_gif;
        this.ceBibliographyHTML = globals.html_small_loading_gif;
        this.ceTranslationEngHTML = globals.html_small_loading_gif;
        this.ceTranslationLatHTML = globals.html_small_loading_gif;
        this.ceCairoEdHTML = globals.html_small_loading_gif;
        this.ceLegendHTML = globals.html_small_loading_gif;

        this.subscriptions.push(
            this.activeRoute.params.subscribe(
                params => {
                    if (params['cedId']) {
                        const cedId = params['cedId'];
                        this.subscriptions.push(
                            this.criticalEditionService.getDocInfo(cedId, this.editionSample).subscribe(
                                ceDocInfo => {
                                    this.setActiveTab('Apparatus');
                                    this.existsTransEng = false;
                                    this.existsTransLat = false;
                                    this.existsCairoEd = false;
                                    this.existsLegend = false;

                                    if (cedId === ceDocInfo.id) { // check if current cedId starts with public/sample edition id

                                        // Translations
                                        if (ceDocInfo.translations && ceDocInfo.translations.length > 0) {
                                            for (const lang of ceDocInfo.translations) {
                                                switch (lang) {
                                                    case 'en':
                                                        this.existsTransEng = true;
                                                        this.subscriptions.push(
                                                            this.criticalEditionService.getTranslationEng(cedId, this.editionSample).subscribe(
                                                                response => this.ceTranslationEngHTML = this.sanitizer.bypassSecurityTrustHtml(response),
                                                                err => console.error(err)
                                                            )
                                                        );
                                                        break;
                                                    case 'la':
                                                        this.existsTransLat = true;
                                                        this.subscriptions.push(
                                                            this.criticalEditionService.getTranslationLat(cedId, this.editionSample).subscribe(
                                                                response => this.ceTranslationLatHTML = this.sanitizer.bypassSecurityTrustHtml(response),
                                                                err => console.error(err)
                                                            )
                                                        );
                                                        break;
                                                }
                                            }
                                        }

                                        this.subscriptions.push(
                                            // Cairo edition
                                            this.appContentsService.getPageContents('cairoed_' + cedId).subscribe(
                                                page => {
                                                    if (page && page.name === ('cairoed_' + cedId)) {
                                                        this.ceCairoEdLastUpdate = page.pubLastDate;
                                                        const pageDescription = page.contents.find(c => c.name === 'description');
                                                        if (pageDescription) {
                                                            this.ceCairoEdHTML = this.sanitizer.bypassSecurityTrustHtml(pageDescription.text);
                                                            this.existsCairoEd = true;
                                                        }
                                                    }
                                                },
                                                err => console.error(err)
                                            ),
                                            // Legend
                                            this.appContentsService.getPageContents('critical_edition_legend').subscribe(
                                                page => {
                                                    if (page && page.name === ('critical_edition_legend')) {
                                                        this.ceLegendLastUpdate = page.pubLastDate;
                                                        const pageDescription = page.contents.find(c => c.name === 'description');
                                                        if (pageDescription) {
                                                            this.ceLegendHTML = this.sanitizer.bypassSecurityTrustHtml(pageDescription.text);
                                                            this.existsLegend = true;
                                                        }
                                                    }
                                                },
                                                err => console.error(err)
                                            )
                                        );
                                    }
                                },
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getApparatus(cedId, this.editionSample).subscribe(
                                response => this.ceApparatusHTML = this.sanitizer.bypassSecurityTrustHtml(response),
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getExegeticNotes(cedId, this.editionSample).subscribe(
                                response => {
                                    if (response.indexOf('edition-empty-data') === -1) {
                                        this.ceExegeticNotesHTML = this.sanitizer.bypassSecurityTrustHtml(response);
                                    } else {
                                        this.ceExegeticNotesHTML = '';
                                    }
                                },
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getBibliography(cedId, this.editionSample).subscribe(
                                response => {
                                    if (response.indexOf('edition-empty-data') === -1) {
                                        this.ceBibliographyHTML = this.sanitizer.bypassSecurityTrustHtml(response);
                                    } else {
                                        this.ceBibliographyHTML = '';
                                    }
                                },
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getAppSelection().subscribe(
                                response => this.updateAppSelection(response),
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getContentSelection().subscribe(
                                response => this.updateContentSelection(response),
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getNoteSelection().subscribe(
                                response => this.updateNoteSelection(response),
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getBiblioSelection().subscribe(
                                response => this.updateBiblioSelection(response),
                                err => console.error(err)
                            ),
                            this.criticalEditionService.getDivSelection().subscribe(
                                response => this.updateDivSelection(response),
                                err => console.error(err)
                            ),
                            this.searchEditionService.getSearchEditionSelected().subscribe(
                                response => this.updateSearchResult(response),
                                err => console.error(err)
                            )
                        );
                    }
                },
                err => console.error(err)
            )
        );
    }

    ngAfterViewInit() {
        this.listeners.push(
            this.renderer.listen(this.ceApparatusRef.nativeElement, 'click', (event) => { this.onClick(event); })
        );
        this.listeners.push(
            this.renderer.listen(this.ceExegeticNotesRef.nativeElement, 'click', (event) => { this.onClickNote(event); })
        );
        this.listeners.push(
            this.renderer.listen(this.ceBibliographyRef.nativeElement, 'click', (event) => { this.onClickBiblio(event); })
        );
        this.listeners.push(
            this.renderer.listen(this.ceTranslationEngRef.nativeElement, 'click', (event) => { this.onClickDiv(event); })
        );
        this.listeners.push(
            this.renderer.listen(this.ceTranslationLatRef.nativeElement, 'click', (event) => { this.onClickDiv(event); })
        );
//        this.listeners.push(
//            this.renderer.listen(this.ceApparatusRef.nativeElement, 'DOMSubtreeModified', (event) => {console.log(event);})
//        );
    }

    onClick(event) {
        event.stopPropagation();

        /* Update content viewer and critical apparatus selections */
        if (event.target.nodeName === 'I') {
            if (event.target.className.indexOf('ced_link') !== -1) {
                this.contentSelection.from = event.target.getAttribute('data-from');
                this.contentSelection.to = event.target.getAttribute('data-to');
                this.criticalEditionService.setContentSelection(this.contentSelection);
                this.updateAppSelection(this.contentSelection, false, false);
            }

            /* Close reference button*/
            if (event.target.className.indexOf('rtt_close') !== -1) {
                this.tooltipService.removeReferenceTooltip();
            }
        }

        /* Filtering by witness */
        if (event.target.id === 'witFilter'
            || (event.target.parentNode && event.target.parentNode.id === 'witFilter')
        ) {
            if (event.target.value) {
                this.witnessSelected = event.target.value;
                const toHideRdgs = this.ceApparatusRef.nativeElement.querySelectorAll(
                    'div.app_row span.rdg:not([data-wits*="#' + this.witnessSelected + '#"])'
                );
                for (const rdg of toHideRdgs) {
                    const parentRow = rdg.closest('div.app_row');
                    this.renderer.setProperty(parentRow, 'hidden', true);
                }
                const toShowRdgs = this.ceApparatusRef.nativeElement.querySelectorAll(
                    'div.app_row span.rdg[data-wits*="#' + this.witnessSelected + '#"]'
                );
                for (const rdg of toShowRdgs) {
                    const parentRow = rdg.closest('div.app_row');
                    this.renderer.setProperty(parentRow, 'hidden', false);
                }
            } else {
                this.resetWitnessFilter();
            }
        }

        if (event.target.nodeName === 'A') {
            if (this.tooltipService.isReferenceLink(event.target.id)) {
                /* Show tooltip */
                this.tooltipService.showReferenceTooltip(event.target, event.target.id);
            }
        }

        /* Reference links */
        if (event.target.nodeName === 'DIV') {
            if (event.target.className.indexOf('ref_link_ms') !== -1) {
                this.zone.run(() => this.router.navigate(['/manuscripts/list/' + event.target.getAttribute('data-target')]));
            } else if (event.target.className.indexOf('ref_link_bib') !== -1) {
                this.zone.run(() => this.router.navigate(['/bibliography', {bibId: event.target.getAttribute('data-target')}]));
            }
        }

        /* Witness info links */
        if (event.target.nodeName === 'SPAN') {
            if (event.target.className.indexOf('rdg_wit') !== -1) {
                const witId = event.target.getAttribute('data-wit');
                if (witId) {
                    this.tooltipService.showReferenceTooltip(event.target, witId);
                }
            }
        }
    }

    resetWitnessFilter() {
        if (this.witnessSelected) {
            const witFilter = this.ceApparatusRef.nativeElement.querySelector('#witFilter');
            if (witFilter) {
                witFilter.selectedIndex = 0;
            }
            const toShowRdgs = this.ceApparatusRef.nativeElement.querySelectorAll('div.app_row');
            for (const rdg of toShowRdgs) {
                const parentRow = rdg.closest('div.app_row');
                this.renderer.setProperty(parentRow, 'hidden', false);
            }
            this.witnessSelected = null;
        }
    }

    updateAppSelection(appSelection: CeSelection, scrollToSelect: boolean = true, resetWitFilter: boolean = true) {
        this.appSelection = appSelection;

        /* Hide the currently selected */
        this.hideSelected();

        if (this.appSelection.isValid()) {
            let querySelect = '';
            const selectStart = appSelection.getFromAsNum();
            const selectEnd = appSelection.getToAsNum();
            const witnessSelected = this.witnessSelected;

            /* Change active tab */
            this.setActiveTab('Apparatus');

            /* Reset witness filter (display all apparatus rows) */
            if (resetWitFilter) {
                this.resetWitnessFilter();
            }

            /* Building of the selection query */
            if (this.appSelection.id) {
                querySelect += '#' + this.appSelection.id;
            } else if (selectStart === selectEnd) {
                querySelect += 'div.app_row[data-from="' + selectStart + '"][data-to="' + selectEnd + '"]';
            } else {
                for (let i = selectStart; i < selectEnd; i++) {
                    if (i > selectStart) {
                        querySelect += ',';
                    }
                    querySelect += 'div.app_row[data-from="' + i + '"]';
                }
            }

            this.appsSelected = this.ceApparatusRef.nativeElement.querySelectorAll(querySelect);
            if (this.appsSelected[0] && scrollToSelect) {
                // this.appsSelected[0].scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                // -- scroll-behavior moved to css
                if (witnessSelected) {
                    window.alert('Apparatus filtering on witness \'' + witnessSelected + '\' has been deactivated.');
                }

                /* Search result highlighting */
                if (this.searchResult && !this.searchResultContainerHtml) {
                    const searchResultContainer = this.getSearchResultContainerElement();
                    if (searchResultContainer) {
                        this.searchResultContainerHtml = searchResultContainer.innerHTML;
                        searchResultContainer.innerHTML = extractKwicInnerHtml(this.searchResult.kwic);
                    }
                }

                this.appsSelected[0].scrollIntoView();
            }

            /* Highlight selected */
            this.highlightSelected();
        }
    }

    updateContentSelection(contentSelection: CeSelection) {
        this.contentSelection = contentSelection;
    }

    onClickNote(event) {
        event.stopPropagation();

        if (event.target.nodeName === 'I') {
            /* Update content viewer and note selections */
            if (event.target.className.indexOf('ced_link') !== -1) {
                this.contentSelection.from = event.target.getAttribute('data-id');
                this.contentSelection.to = this.contentSelection.from;
                this.criticalEditionService.setContentSelection(this.contentSelection);
                this.updateNoteSelection(this.contentSelection, false);
            }

            /* Close reference button*/
            if (event.target.className.indexOf('rtt_close') !== -1) {
                this.tooltipService.removeReferenceTooltip();
            }
        }

        if (event.target.nodeName === 'A') {
            if (this.tooltipService.isReferenceLink(event.target.id)) {
                /* Show tooltip */
                this.tooltipService.showReferenceTooltip(event.target, event.target.id);
            }
        }

        /* Reference links */
        if (event.target.nodeName === 'DIV') {
            if (event.target.className.indexOf('ref_link_ms') !== -1) {
                this.zone.run(() => this.router.navigate(['/manuscripts/list/' + event.target.getAttribute('data-target')]));
            } else if (event.target.className.indexOf('ref_link_bib') !== -1) {
                this.zone.run(() => this.router.navigate(['/bibliography', {bibId: event.target.getAttribute('data-target')}]));
            }
        }
    }

    onClickBiblio(event) {
        event.stopPropagation();

        /* Update content viewer and bibliography selections */
        if (event.target.nodeName === 'I' && event.target.className.indexOf('ced_link') !== -1) {
            this.contentSelection.from = event.target.getAttribute('data-id');
            this.contentSelection.to = 'e-' + this.contentSelection.from;
            this.criticalEditionService.setContentSelection(this.contentSelection);
            this.updateBiblioSelection(this.contentSelection, false);
        } else if (event.target.nodeName === 'BUTTON') {
            const fullRefElement = this.ceBibliographyRef.nativeElement.querySelector(
                event.target.getAttribute('data-target')
            );
            fullRefElement.classList.toggle('in');
        }
    }

    updateNoteSelection(noteSelection: CeSelection, scrollToSelect: boolean = true) {
        this.noteSelection = noteSelection;

        /* Hide the currently selected */
        this.hideSelected();

        if (noteSelection.from) {
            /* Change active tab */
            this.setActiveTab('Notes');

            const querySelect = 'div.note_row[data-id="' + noteSelection.from + '"]';
            this.notesSelected = this.ceExegeticNotesRef.nativeElement.querySelectorAll(querySelect);
            if (this.notesSelected[0] && scrollToSelect) {
                /* Search result highlighting */
                if (this.searchResult && !this.searchResultContainerHtml) {
                    const searchResultContainer = this.getSearchResultContainerElement();
                    if (searchResultContainer) {
                        this.searchResultContainerHtml = searchResultContainer.innerHTML;
                        searchResultContainer.innerHTML = extractKwicInnerHtml(this.searchResult.kwic);
                    }
                }

                // this.notesSelected[0].scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                // -- scroll-behavior moved to css
                this.notesSelected[0].scrollIntoView();
            }

            /* Highlight selected */
            this.highlightSelected();
        }
    }

    updateBiblioSelection(biblioSelection: CeSelection, scrollToSelect: boolean = true) {
        this.biblioSelection = biblioSelection;
        let querySelect = '';

        /* Hide the currently selected */
        this.hideSelected();

        if (biblioSelection.from) {
            /* Change active tab */
            this.setActiveTab('Bibliography');

            /* Build select query */
            const biblioIdList = biblioSelection.from.split(':');
            let biblioIdCount = 0;
            for (const biblioId of biblioIdList) {
                biblioIdCount++;
                if (biblioIdCount === 1) {
                    querySelect += 'div.bib_row[data-id="' + biblioId + '"]';
                } else {
                    querySelect += ',div.bib_row[data-id="' + biblioId + '"]';
                }
            }

            /* Update selection */
            this.biblioSelected = this.ceBibliographyRef.nativeElement.querySelectorAll(querySelect);
            if (this.biblioSelected[0] && scrollToSelect) {
                // this.biblioSelected[0].scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                // -- scroll-behavior moved to css
                this.biblioSelected[0].scrollIntoView();
            }

            /* Highlight selected */
            this.highlightSelected();
        }
    }

    onClickDiv(event) {
        event.stopPropagation();

        if (event.target.nodeName === 'A') {
            /* Update content viewer and translation selections */
            if (event.target.className.indexOf('trans_link') !== -1) {
                let langSuffix = null;
                switch (this.activeTab) {
                    case 'TranslationEng': langSuffix = 'en-'; break;
                    case 'TranslationLat': langSuffix = 'la-'; break;
                }
                if (langSuffix) {
                    this.contentSelection.from = langSuffix + event.target.getAttribute('data-corresp').replace('ar-', '');
                    this.contentSelection.to = this.contentSelection.from;
                    this.criticalEditionService.setContentSelection(this.contentSelection);
                    this.updateDivSelection(this.contentSelection.from, false);
                }
            }
        }
    }

    updateDivSelection(divSelection: string, scrollToSelect: boolean = true) {
        this.divSelection = divSelection;

        /* Hide the currently selected */
        this.hideSelected();

        if (this.divSelection.length > 0) {
            const lang = this.divSelection.substr(0, 2);
            let transElementRef = null;

            switch (lang) {
                case 'en':
                    /* Change active tab */
                    this.setActiveTab('TranslationEng');
                    transElementRef = this.ceTranslationEngRef;
                    break;
                case 'la':
                    /* Change active tab */
                    this.setActiveTab('TranslationLat');
                    transElementRef = this.ceTranslationLatRef;
                    break;
            }

            if (transElementRef) {
                const divSelectionId = this.divSelection.substr(3); // discard lang
                this.divSelected = transElementRef.nativeElement.querySelector('[id="' + divSelectionId + '"] a[class="trans_link"]');
                if (!this.divSelected) {
                    /* Direct access to the element and not to its parent link - avoid highlighting the entire div */
                    const divSelected = transElementRef.nativeElement.querySelector('[xml\\:id="' + divSelectionId + '"]');
                    if (divSelected) {
                        divSelected.scrollIntoView();
                    }
                }
                if (this.divSelected && scrollToSelect) {
                    // this.divSelected.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                    // -- scroll-behavior moved to css
                    this.divSelected.scrollIntoView();
                }

                /* Highlight selected */
                this.highlightSelected();

                /* Search result highlighting */
                if (this.searchResult && !this.searchResultContainerHtml) {
                    const searchResultLang = this.searchResult.section.replace('trans_', '');
                    if (searchResultLang === lang) {
                        const searchResultContainer = this.getSearchResultContainerElement();
                        if (searchResultContainer) {
                            this.searchResultContainerHtml = searchResultContainer.innerHTML;
                            searchResultContainer.innerHTML = extractKwicInnerHtml(this.searchResult.kwic);
                            searchResultContainer.scrollIntoView();
                        }
                    }
                }
            }
        }
    }

    highlightSelected() {
        if (this.appsSelected) {
            for (const selected of this.appsSelected) {
                selected.style.backgroundColor = '#FFDAB9';
            }
        }
        if (this.notesSelected) {
            for (const selected of this.notesSelected) {
                selected.style.backgroundColor = '#FFDAB9';
            }
        }
        if (this.biblioSelected) {
            for (const selected of this.biblioSelected) {
                selected.style.backgroundColor = '#FFDAB9';
            }
        }
        if (this.divSelected) {
            this.divSelected.style.color = '#6A93A4';
            this.divSelected.style.backgroundColor = '#FFDAB9';
        }
    }

    hideSelected() {
        if (this.appsSelected) {
            for (const selected of this.appsSelected) {
                selected.style.backgroundColor = '#F7F7F7';
            }
        }
        if (this.notesSelected) {
            for (const selected of this.notesSelected) {
                selected.style.backgroundColor = '#F7F7F7';
            }
        }
        if (this.biblioSelected) {
            for (const selected of this.biblioSelected) {
                selected.style.backgroundColor = '#F7F7F7';
            }
        }
        if (this.divSelected) {
            this.divSelected.style.color = '#C9302C';
            this.divSelected.style.backgroundColor = '#FFFFFF';
        }
    }

    setActiveTab(activeTab: CeApparatusTabs) {
        this.activeTab = activeTab;
        switch (this.activeTab) {
            case 'Apparatus':
                this.ceApparatusRef.nativeElement.classList.add('in', 'active');
                this.ceExegeticNotesRef.nativeElement.classList.remove('active');
                this.ceBibliographyRef.nativeElement.classList.remove('active');
                this.ceTranslationEngRef.nativeElement.classList.remove('active');
                this.ceTranslationLatRef.nativeElement.classList.remove('active');
                this.ceCairoEdRef.nativeElement.classList.remove('active');
                this.ceLegendRef.nativeElement.classList.remove('active');
                break;
            case 'Notes':
                this.ceApparatusRef.nativeElement.classList.remove('active');
                this.ceExegeticNotesRef.nativeElement.classList.add('in', 'active');
                this.ceBibliographyRef.nativeElement.classList.remove('active');
                this.ceTranslationEngRef.nativeElement.classList.remove('active');
                this.ceTranslationLatRef.nativeElement.classList.remove('active');
                this.ceCairoEdRef.nativeElement.classList.remove('active');
                this.ceLegendRef.nativeElement.classList.remove('active');
                break;
            case 'Bibliography':
                this.ceApparatusRef.nativeElement.classList.remove('active');
                this.ceExegeticNotesRef.nativeElement.classList.remove('active');
                this.ceBibliographyRef.nativeElement.classList.add('in', 'active');
                this.ceTranslationEngRef.nativeElement.classList.remove('active');
                this.ceTranslationLatRef.nativeElement.classList.remove('active');
                this.ceCairoEdRef.nativeElement.classList.remove('active');
                this.ceLegendRef.nativeElement.classList.remove('active');
                break;
            case 'TranslationEng':
                this.ceApparatusRef.nativeElement.classList.remove('active');
                this.ceExegeticNotesRef.nativeElement.classList.remove('active');
                this.ceBibliographyRef.nativeElement.classList.remove('active');
                this.ceTranslationEngRef.nativeElement.classList.add('in', 'active');
                this.ceTranslationLatRef.nativeElement.classList.remove('active');
                this.ceCairoEdRef.nativeElement.classList.remove('active');
                this.ceLegendRef.nativeElement.classList.remove('active');
                break;
            case 'TranslationLat':
                this.ceApparatusRef.nativeElement.classList.remove('active');
                this.ceExegeticNotesRef.nativeElement.classList.remove('active');
                this.ceBibliographyRef.nativeElement.classList.remove('active');
                this.ceTranslationEngRef.nativeElement.classList.remove('active');
                this.ceTranslationLatRef.nativeElement.classList.add('in', 'active');
                this.ceCairoEdRef.nativeElement.classList.remove('active');
                this.ceLegendRef.nativeElement.classList.remove('active');
                break;
            case 'CairoEd':
                this.ceApparatusRef.nativeElement.classList.remove('active');
                this.ceExegeticNotesRef.nativeElement.classList.remove('active');
                this.ceBibliographyRef.nativeElement.classList.remove('active');
                this.ceTranslationEngRef.nativeElement.classList.remove('active');
                this.ceTranslationLatRef.nativeElement.classList.remove('active');
                this.ceCairoEdRef.nativeElement.classList.add('in', 'active');
                this.ceLegendRef.nativeElement.classList.remove('active');
                break;
            case 'Legend':
                this.ceApparatusRef.nativeElement.classList.remove('active');
                this.ceExegeticNotesRef.nativeElement.classList.remove('active');
                this.ceBibliographyRef.nativeElement.classList.remove('active');
                this.ceTranslationEngRef.nativeElement.classList.remove('active');
                this.ceTranslationLatRef.nativeElement.classList.remove('active');
                this.ceCairoEdRef.nativeElement.classList.remove('active');
                this.ceLegendRef.nativeElement.classList.add('in', 'active');
                break;
        }
    }

    private getSearchResultContainerElement(): any|null {
        if (this.searchResult) {
            switch (this.activeTab) {
                case 'Apparatus':
                    return this.ceApparatusRef.nativeElement.querySelector('#' + this.searchResult.id + '>data-app');
                case 'Notes':
                    const notesSelected = this.ceExegeticNotesRef.nativeElement.querySelectorAll('div.note_row[data-id="' + this.searchResult.id + '"]');
                    if (notesSelected) {
                        return notesSelected[0];
                    }
                break;
                case 'TranslationEng':
                    if (isTeiHeadKwic(this.searchResult.kwic)) {
                        return this.ceTranslationEngRef.nativeElement.querySelector('[xml\\:id="' + this.searchResult.id + '"]>data-head');
                    } else {
                        return this.ceTranslationEngRef.nativeElement.querySelector('[xml\\:id="' + this.searchResult.id + '"]');
                    }
                case 'TranslationLat':
                    if (isTeiHeadKwic(this.searchResult.kwic)) {
                        return this.ceTranslationLatRef.nativeElement.querySelector('[xml\\:id="' + this.searchResult.id + '"]>data-head');
                    } else {
                        return this.ceTranslationLatRef.nativeElement.querySelector('[xml\\:id="' + this.searchResult.id + '"]');
                    }
            }
        }
        return null;
    }

    updateSearchResult(searchResult?: SearchEditionResultRow) {
        /* Restore original content */
        if (!searchResult) {
            const searchResultContainer = this.getSearchResultContainerElement();
            if (searchResultContainer && this.searchResultContainerHtml) {
                searchResultContainer.innerHTML = this.searchResultContainerHtml;
                this.searchResultContainerHtml = null;
            }
        }

        this.searchResult = searchResult;
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
        for (const listener of this.listeners) {
            if (listener) {
                listener();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/ce-apparatus/ce-apparatus.component.ts